import { type WidgetSetting, type hfb } from "@repo/api";
import { addDays, endOfDay, startOfDay } from "date-fns";

import { getCoworkerSettingsValue } from "../../customize/settings/CoworkerSettingsControl";

export const getWidgetSettings = (settings?: WidgetSetting) => {
  const { email, teamId, assignedToTeam } = getCoworkerSettingsValue(
    settings?.["COWORKER"]?.toString() ?? ""
  );

  const unitIds = settings?.STORE
    ? Array.isArray(settings.STORE)
      ? settings.STORE
      : [settings.STORE]
    : undefined;

  const expireRange = settings?.expiringIn as string[] | undefined;
  const getExpireDate = () => {
    if (!expireRange) {
      return [];
    }

    const from = startOfDay(addDays(new Date(), Number(expireRange[0])));
    const to = endOfDay(addDays(new Date(), Number(expireRange[1])));

    return [from, to];
  };

  const department =
    settings?.DEPARTMENT !== undefined ? (settings.DEPARTMENT as hfb[]) : [];

  return {
    unitIds,
    email: email,
    teamId,
    assignedToTeam,
    quotationStatus: settings?.status ?? [],
    quotationValue: settings?.quotationValue ?? [],
    quotationCustomerType: settings?.customerType ?? [],
    expiryDate: getExpireDate(),
    departmentFilter: department,
  };
};

export const mapQuotationData = <T>(existingArray: T[], newArray: T[]): T[] => {
  const uniqueItems = new Set([
    ...existingArray.map((item) => JSON.stringify(item)),
    ...newArray.map((item) => JSON.stringify(item)),
  ]);
  return Array.from(uniqueItems).map((item) => JSON.parse(item));
};
